
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Wagholitomumbaicab() {



    const cardData =
    {
        keyword: 'Wagholi to Mumbai Cab',
        heading: 'Skyline Cabs: Wagholi to Mumbai Cab',
        headingDescription: 'Skyline Cabs offers trusted and affordable Wagholi to Mumbai Cab services for a safe and comfortable journey. Whether you are traveling for work, vacation, or airport transfers, our experienced drivers and clean, well-maintained vehicles ensure a smooth and hassle-free ride. With punctual service, transparent pricing, and 24/7 availability, Skyline Cabs is your ideal choice for travel from Wagholi to Mumbai. Book now and enjoy a relaxed and reliable cab experience.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],

"services": [
    {
      "name": "Wagholi to Mumbai Cab Price",
      "description": "Skyline Cabs offers competitive and transparent pricing for cab rides from Wagholi to Mumbai. Our rates include fuel, tolls, and driver charges with no hidden costs. Book a sedan, Ertiga, or Innova for a smooth, budget-friendly ride to Mumbai."
    },
    {
      "name": "Wagholi to Mumbai Cab",
      "description": "Book your cab from Wagholi to Mumbai with Skyline Cabs for a hassle-free journey. Choose from a range of vehicles including sedans, 7-seaters, and luxury options for your comfort. Ideal for families, business travelers, and airport transfers."
    },
    {
      "name": "Wagholi to Mumbai Airport Cab Service",
      "description": "Skyline Cabs provides reliable airport transfer services from Wagholi to Mumbai Airport. Our professional drivers ensure timely pickups and a comfortable ride to either the domestic or international terminals."
    },
    {
      "name": "Mumbai to Wagholi Cab Service",
      "description": "Need a ride back from Mumbai to Wagholi? Skyline Cabs offers one-way and round-trip cab services with door-to-door pickups, well-maintained vehicles, and experienced drivers to ensure a smooth return trip."
    },
    {
      "name": "Kharadi to Mumbai Airport Cab Service",
      "description": "Skyline Cabs offers timely and comfortable cab services from Kharadi to Mumbai Airport. Perfect for business or personal travel, our fleet includes Innova Crysta, Ertiga, and sedans with trained chauffeurs for a safe trip."
    },
    {
      "name": "Kharadi to Mumbai Airport Cab Service Rates",
      "description": "Our cab fare from Kharadi to Mumbai Airport is designed to be competitive and transparent. Choose from multiple vehicle options with upfront pricing, including all applicable charges and taxes."
    },
    {
      "name": "Lohegaon to Mumbai Airport Cab",
      "description": "Skyline Cabs provides punctual and safe cab service from Lohegaon to Mumbai Airport. Book online or call us anytime for one-way or round-trip options with AC vehicles and professional drivers."
    },
    {
      "name": "Perne Phata to Mumbai Airport Cab",
      "description": "Get convenient and affordable cab services from Perne Phata to Mumbai Airport with Skyline Cabs. Our drivers ensure timely pickups and smooth rides with GPS-enabled vehicles and 24/7 support."
    },
    {
      "name": "Kesnand to Mumbai Cab Service",
      "description": "Skyline Cabs offers dependable cab service from Kesnand to Mumbai. Whether you're heading for work, a family visit, or airport travel, enjoy stress-free travel with our comfortable fleet and professional drivers."
    },
    {
      "name": "Uruli Kanchan to Mumbai Cabs Service",
      "description": "Travel from Uruli Kanchan to Mumbai with ease using Skyline Cabs. Book sedans or SUVs for a smooth journey with competitive pricing and flexible one-way or return options."
    },
    {
      "name": "Mundwa to Mumbai Cabs Service",
      "description": "Skyline Cabs offers safe and professional cab services from Mundwa to Mumbai. Enjoy door-to-door service, timely arrivals, and a comfortable ride with trained drivers in clean, sanitized vehicles."
    },
    {
      "name": "Manjari to Mumbai Cabs Service",
      "description": "Looking for a cab from Manjari to Mumbai? Skyline Cabs has got you covered. We provide one-way and round-trip bookings with air-conditioned vehicles and experienced chauffeurs for a seamless experience."
    },
    {
      "name": "Pune Nagar Road to Mumbai Cabs Service",
      "description": "Skyline Cabs provides cab services from Pune Nagar Road to Mumbai. Book our sedans, SUVs, or Ertigas for a comfortable and reliable ride to Mumbai city or airport, available 24/7."
    },
    {
      "name": "Cab Service in Wagholi",
      "description": "Skyline Cabs is your trusted taxi partner in Wagholi. We offer airport drops, outstation cabs to Mumbai, and local travel with well-maintained vehicles, professional drivers, and 24x7 service availability."
    },
    {
      "name": "Innova Crysta on Rent in Wagholi",
      "description": "Skyline Cabs offers Innova Crysta on rent in Wagholi for intercity and outstation travel. Ideal for families and groups, the Innova Crysta offers spacious seating, a luxurious interior, and a comfortable travel experience."
    },
    {
      "name": "Ertiga on Rent in Wagholi",
      "description": "Need a spacious yet budget-friendly cab in Wagholi? Rent an Ertiga with Skyline Cabs. Perfect for Mumbai trips and airport transfers, our Ertigas offer ample space, AC comfort, and trained drivers."
    },
    {
      "name": "Sedan Cabs on Rent in Wagholi",
      "description": "For solo travelers or small families, Skyline Cabs offers sedan cars like Swift Dzire, Etios, and Xcent on rent in Wagholi. Choose us for affordable, safe, and on-time travel to Mumbai and beyond."
    },
    {
      "name": "Cab Service in Wagholi",
      "description": "Skyline Cabs provides end-to-end taxi solutions in Wagholi. From airport transfers to full-day rentals, our fleet includes sedans, Ertiga, and luxury cars—available for bookings any time of the day or night."
    }
  ],
  "tableData": [
    ["Wagholi to Mumbai Cab Price", "Wagholi to Mumbai Cab"],
    ["Wagholi to Mumbai Airport Cab Service", "Mumbai to Wagholi Cab Service"],
    ["Kharadi to Mumbai Airport Cab Service", "Kharadi to Mumbai Airport Cab Service Rates"],
    ["Lohegaon to Mumbai Airport Cab", "Perne Phata to Mumbai Airport Cab"],
    ["Kesnand to Mumbai Cab Service", "Uruli Kanchan to Mumbai Cabs Service"],
    ["Mundwa to Mumbai Cabs Service", "Manjari to Mumbai Cabs Service"],
    ["Pune Nagar Road to Mumbai Cabs Service", "Cab Service in Wagholi"],
    ["Innova Crysta on Rent in Wagholi", "Ertiga on Rent in Wagholi"],
    ["Sedan Cabs on Rent in Wagholi", "Cab Service in Wagholi"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Wagholi to Mumbai Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable and on-time cab services from Wagholi to Mumbai, ensuring you reach your destination without any hassle. Whether it’s for business, a special event, or a quick getaway, we ensure a punctual and comfortable experience every time."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Travel in comfort with Skyline Cabs. Our fleet includes a variety of vehicles, including sedans, SUVs, and luxury cars. Each vehicle is well-maintained, air-conditioned, and designed to provide a smooth, comfortable ride with ample space for luggage and passengers."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are highly experienced and trained to ensure a safe, efficient, and pleasant journey. Familiar with the best routes from Wagholi to Mumbai, they guarantee a hassle-free trip, all while providing courteous and professional service."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Skyline Cabs offers affordable pricing for your Wagholi to Mumbai trip. Our fare structure is transparent, with no hidden charges. You'll always know the cost upfront, making your ride budget-friendly and stress-free."
    },
    {
        "WhyChooseheading": "Available 24/7 for Your Convenience",
        "WhyChoosedescription": "Our services are available 24/7, meaning you can book a cab from Wagholi to Mumbai at any time. Whether it's an early morning or late-night journey, we ensure that you have reliable transportation whenever you need it."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicle Options",
        "WhyChoosedescription": "Whether you're traveling solo, with family, or in a group, Skyline Cabs has the right vehicle for your needs. Choose from sedans, spacious SUVs, or premium cars, all designed to offer you a comfortable and enjoyable ride."
    },
    {
        "WhyChooseheading": "Easy Booking Process with Instant Confirmation",
        "WhyChoosedescription": "Booking a cab from Wagholi to Mumbai is quick and simple with Skyline Cabs. You can book your ride through our website or mobile app and get instant confirmation. Plus, enjoy the convenience of real-time tracking of your cab."
    },
    {
        "WhyChooseheading": "Safe and Secure Ride Every Time",
        "WhyChoosedescription": "Your safety is our top priority. All Skyline Cabs are GPS-enabled for real-time tracking, and our drivers undergo thorough background checks. You can relax and enjoy a secure and comfortable ride from Wagholi to Mumbai."
    }
]













    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a cab from Wagholi to Mumbai with Skyline Cabs?',
            answer:
                'Booking a cab is simple! You can book your ride through our website or mobile app. Just enter Wagholi as your pickup point and Mumbai as your destination. Select the vehicle of your choice, confirm the details, and you’re all set.',
        },
        {
            id: 2,
            question: 'What types of cabs are available for Wagholi to Mumbai?',
            answer:
                'Skyline Cabs offers a range of vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Choose a vehicle that fits your travel preferences and comfort needs.',
        },
        {
            id: 3,
            question: 'Is the pricing fixed for Wagholi to Mumbai cabs?',
            answer:
                'Yes, Skyline Cabs offers fixed, upfront pricing. The fare includes tolls, driver charges, and taxes. You will know the total cost before confirming your booking — no hidden charges!',
        },
        {
            id: 4,
            question: 'Can I book a round-trip cab from Wagholi to Mumbai?',
            answer:
                'Absolutely! You can easily book both one-way and round-trip rides. If you need a return trip, simply provide the return details during your booking, and we’ll handle everything.',
        },
        {
            id: 5,
            question: 'How long does it take to travel from Wagholi to Mumbai?',
            answer:
                'Typically, it takes around 4 to 4.5 hours depending on traffic conditions. Our drivers are skilled at choosing the best routes to ensure a smooth and timely journey.',
        },
        {
            id: 6,
            question: 'Are the drivers experienced for long-distance trips like Wagholi to Mumbai?',
            answer:
                'Yes, our drivers are professional, experienced, and familiar with the route from Wagholi to Mumbai. They ensure a safe, comfortable, and hassle-free ride.',
        },
        {
            id: 7,
            question: 'Can I book a cab from Wagholi to Mumbai Airport?',
            answer:
                'Yes, we offer reliable airport transfer services. Whether you’re traveling to or from Mumbai’s Domestic or International Airport, we’ll ensure a timely and stress-free journey.',
        },
        {
            id: 8,
            question: 'Are the cabs comfortable and clean?',
            answer:
                'Absolutely! All Skyline cabs are well-maintained, thoroughly cleaned, and air-conditioned. Your comfort and safety are our top priorities.',
        },
        {
            id: 9,
            question: 'Can I modify or cancel my booking if my travel plans change?',
            answer:
                'Yes, we offer flexibility with booking cancellations or modifications. You can easily manage your booking via the app or website or by contacting our customer support team.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Wagholi to Mumbai journey?',
            answer:
                'Skyline Cabs is known for its punctuality, clean vehicles, professional drivers, and transparent pricing. Whether it is a business trip, a family outing, or an airport transfer, we ensure a smooth and stress-free journey from Wagholi to Mumbai.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Abhishek Kulkarni",
            rating: 5,
            review: "I booked a cab from Wagholi to Mumbai for a business meeting. The driver was professional, the car was clean, and I reached well ahead of time. Very reliable service — will definitely use Skyline Cabs again."
        },
        {
            name: "Miss. Riya Desai",
            rating: 4,
            review: "The ride from Wagholi to Mumbai was comfortable, and the car was in great condition. The driver was friendly and knew the route well. Would have appreciated a little more space in the backseat, but overall, a great service!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



  const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wagholi to Mumbai Cabs",
  "image": "https://skylinecabs.com/assets/images/wagholi-to-mumbai-cab.jpg",
  "description": "Book Wagholi to Mumbai cabs with Skyline Cabs for affordable, safe, and comfortable travel. Choose AC sedans or SUVs with professional drivers—available 24/7 for one-way and round-trip bookings.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7423"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/wagholi-to-mumbai-cabs"
  }
};



      
     
      

    return (
        <div>





<Helmet>
  <title>Wagholi to Mumbai Cabs | 24/7 AC Taxi Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Wagholi to Mumbai cabs with Skyline Cabs for affordable, safe, and comfortable travel. Choose AC sedans or SUVs with professional drivers—available 24/7 for one-way and round-trip bookings." 
  />
  <meta 
    name="keywords" 
    content="Wagholi to Mumbai Cabs, Cab from Wagholi to Mumbai, One-Way Taxi Wagholi to Mumbai, Round Trip Cab Wagholi to Mumbai, AC Cab Wagholi to Mumbai, SUV Taxi Wagholi to Mumbai, Online Cab Booking Wagholi to Mumbai, Affordable Taxi Wagholi to Mumbai, Skyline Cabs Wagholi to Mumbai, 24/7 Cab Service Wagholi to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/28.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Wagholitomumbaicab;